import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2cf778d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "show-invited-modal" }
const _hoisted_2 = { class: "show-invited-modal__inner" }
const _hoisted_3 = { class: "show-invited-modal__icon" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Only invited contractors can send estimate on this project", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_GeneralDialog = _resolveComponent("GeneralDialog")!

  return (_openBlock(), _createBlock(_component_GeneralDialog, { onOnClose: $setup.onCloseInviteModal }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_icon, {
              icon: "mdi-check",
              color: "#fff"
            })
          ]),
          _createElementVNode("h2", null, _toDisplayString($props.isInviteOnlyProject
                ? `Project Open to Invited Contractors Only`
                : `This project is now open to all Contractors.`), 1),
          _hoisted_4
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_v_btn, {
        onClick: $setup.onCloseInviteModal,
        class: "button button-orange !tw-font-bold"
      }, {
        default: _withCtx(() => [
          _createTextVNode("CLOSE")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }, 8, ["onOnClose"]))
}